nn.component.FileField = function (element) {
  var parent = element.parentElement;

  var wrapper = document.createElement('div');
  wrapper.className = 'file-field-wrapper';
  wrapper.setAttribute('role', 'group');
  wrapper.setAttribute('aria-label', 'File upload field');

  var fakeText = document.createElement('input');
  fakeText.className = 'c-form-text file-field-wrapper__text';
  fakeText.setAttribute('aria-label', 'Selected file name');
  fakeText.readOnly = true; // Prevent manual editing
  wrapper.appendChild(fakeText);

  var fakeButton = document.createElement('button');
  fakeButton.type = 'button';
  fakeButton.className = 'file-field-wrapper__button';
  fakeButton.textContent = 'Bestand kiezen';
  fakeButton.setAttribute('aria-label', 'Bestand kiezen');
  wrapper.appendChild(fakeButton);

  parent.insertBefore(wrapper, element);
  wrapper.appendChild(element);

  element.setAttribute('aria-hidden', 'true');
  element.style.display = 'none';

  fakeButton.addEventListener('click', function () {
    element.click(); // Trigger the file input
  });

  element.addEventListener('change', function () {
    fakeText.value = element.files[0] ? element.files[0].name : 'No file selected';
  });
};
